<template>
<div>
  <product-card :product="product" />
  <vx-card v-if="batchNo && product.enableBatch" :title="'当前商品批号: ' + batchNo" class="mb-10 pb-5">
    <vs-button color="primary" @click="editBatchNo" v-if="$acl.check('batch_edit')">修改批号</vs-button>
    <vs-button color="danger" class="ml-2" @click="willRemoveBatchNo" v-if="$acl.check('batch_edit')">删除批号</vs-button>
  </vx-card>
  <vx-card title="溯源内容列表" class="trace-list vs-space-table mb-10">
   <paging-list 
    :data="traceList" 
    :pagination="false"
  >
      <div slot="header" class="top w-full">
        <vs-button class="mr-3 mb-2" @click="$modal('previewTraceQr', { batchID })">
          预览溯源页面
        </vs-button>
        <vs-button class="mr-3 mb-2" @click="fetchTrace">
          刷新
        </vs-button>
        <vs-button v-if="$acl.check('batch_edit')" :to="'/batchno/' + batchID + '/trace/create'" color="primary" type="border" class="mb-4 mr-4 cursor-pointer items-center justify-between font-medium text-base text-primary border border-solid border-primary">
          <icon icon="PlusIcon" svgClasses="h-4 w-4" style="top: 2px" />
          新建溯源内容
        </vs-button>
      </div>
      <template slot="thead">
      <vs-th>类型</vs-th>
      <vs-th>内容</vs-th>
      <vs-th>时间</vs-th>
      <vs-th v-if="$acl.check('batch_edit')">操作</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td>{{tr.type}}</vs-td>
        <vs-td><div v-html="tr.content"></div></vs-td>
        <vs-td>{{tr.time | datetime('YYYY-MM-DD hh:MM')}}</vs-td>
        <vs-td v-if="$acl.check('batch_edit')">
          <router-link :to="'/batchno/' + batchID + '/trace/edit/' + tr.id">编辑</router-link>
          <a class="text-danger ml-5" @click="willRemoveTrace(tr)">删除</a>
        </vs-td>
      </vs-tr>
    </template>
   </paging-list>
  </vx-card>

  <vx-card title="订单列表" class="order-list mb-10 vs-space-table" v-if="$acl.check('order_list')">
   <paging-list 
    :data="orderList"
    :pagination="false"
  >
      <div slot="header" class="top w-full" v-if="$acl.check('order_edit')">
        <vs-button class="mr-3 mb-2" :to="'/batchno/'+batchID+'/order/create'">
          创建购买订单
        </vs-button>
      </div>
      <template slot="thead">
        <vs-th>订单号</vs-th>
        <vs-th>标题</vs-th>
        <vs-th>数量</vs-th>
        <vs-th>二维码有效期</vs-th>
        <vs-th>印刷服务</vs-th>
<!--        <vs-th>标签</vs-th>-->
        <vs-th>收货信息</vs-th>
        <vs-th>订单状态</vs-th>
        <vs-th>价格</vs-th>
        <vs-th>下单时间</vs-th>
        <vs-th v-if="$acl.check('order_edit')">操作</vs-th>
        <vs-th v-if="$acl.check('order_admin')">管理员操作</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{tr.orderid}}</vs-td>
          <vs-td>{{tr.title}}</vs-td>
          <vs-td>{{tr.number}}</vs-td>
          <vs-td><span v-if="tr.qrExpire">{{$s.dict.priceMap.qrExpire[tr.qrExpire].name}}</span></vs-td>
          <vs-td>{{tr.printing ? '需要':'不需要'}}</vs-td>
<!--          <vs-td>{{tr.stickyID}}</vs-td>-->
          <vs-td>
            <div>联系人: {{tr.contactName}}</div>
            <div>联系电话: {{tr.contactPhone}}</div>
            <div>收货地址: {{tr.address}}</div>
          </vs-td>
          <vs-td>{{orderStatus[tr.status]}}</vs-td>
          <vs-td><span class="text-danger">￥{{(tr.amount / 100).toFixed(2)}}元</span></vs-td>
          <vs-td>{{tr.createdAt| datetime}}</vs-td>
          <vs-td v-if="$acl.check('order_edit')">
            <span v-if="tr.status < 20" class="text-primary cursor-pointer mr-5" @click="$router.push('/order/pay/' + tr.orderid)">立即支付</span>
            <span v-if="tr.status < 20" class="text-primary cursor-pointer mr-5" @click="cancelOrder(tr)">取消订单</span>
            <a v-if="tr.status == 23" :href="downloadBase + tr.orderid" class="mr-5" target="_blank" rel="noopener noreferrer">下载二维码</a>
          </vs-td>
          <vs-td v-if="$acl.check('order_admin')">
            撒范德萨
          </vs-td>
        </vs-tr>
      </template>
    </paging-list>
  </vx-card>
</div>
</template>
<script>
import ProductCard from './product-card'
export default {
  components: {
    ProductCard,
  },
  data() {
    return {
      downloadBase: window.__CONFIG__.api + '/admin/v1/order/download/',
      traceList: [],
      orderList: [],
    }
  },
  $computed: ['product.batchno.product', 'product.batchno.batchNo', 'dict.orderStatus'],
  computed: {
    batchID() {
      return this.$route.params.batchID
    }
  },
  async mounted() {
    this.$s.product.batchNoDetail(this.batchID)
    this.fetchTrace()
    this.fetchOrder()
  },
  methods: {
    onTracePageChange() {},
    editBatchNo() {
      this.$modal('editBatchNo', {
        batch: this.$s.product.batchno,
        product: this.product,
        onOk(batch) {
          this.$s.product.batchno.batchNo = batch.batchNo
        }
      })
    },
    async fetchTrace() {
      const traceList = await this.$s.product.traceList(this.batchID)
      this.traceList = traceList
    },
    async fetchOrder() {
      const res = await this.$s.order.batchNoOrder(this.batchID)
      this.orderList = res.list
    },
    willRemoveBatchNo() {
      this.$confirm({
        color: 'danger',
        title: '确定删除该商品批号？',
        text: '删除后该批号后，对应的溯源内容，订单都将一并删除，并且不可恢复，是否确认？',
        accept: async () => {
          await this.$s.product.batchNoRemove(this.batchID)
          this.$notify({
            title: '删除成功',
          })
          this.$router.push('/product/list')
        }
      })
    },
    willRemoveTrace(item) {
      this.$confirm({
        color: 'danger',
        title: '确定删除该溯源内容？',
        text: '删除后该溯源内容将消失，并且不可恢复',
        accept: async () => {
          await this.$s.product.traceRemove(item.id)
          this.traceList = this.traceList.filter(x => x.id != item.id)
        }
      })
    },
    cancelOrder(order) {
      this.$confirm({
        color: 'danger',
        title: '确定取消该订单？',
        text: '取消订单后，改笔订单将作废',
        accept: async () => {
          await this.$s.order.cancel(order.orderid)
          order.status = 25
        }
      })
    }
  }
}
</script>